import React from 'react';
import { Form } from 'react-bootstrap';

import FormRow from '../../app/components/FormRow';
import { CreateUpdateCardDto } from '../spdCore/autogenerated/spdApiClient';

export const RadioButtonTextsWithDesc: React.FC<{
  name: string;
  value: string | undefined | null;
  field: Partial<CreateUpdateCardDto>;
  onChange: (obj: Partial<CreateUpdateCardDto>) => void;
  texts: string[];
}> = props => {
  return (
    <div key={`inline-${props.name}`} className="mb-3">
      <FormRow controlId={`postDate-${props.name}`} label={props.name}>
        {props.texts.map((text, index) => (
          <Form.Check
            inline
            label={text}
            name={`group-${props.name}`}
            type="radio"
            id={`${index}-norm-${props.name}`}
            key={index}
            checked={f(props.value === text)}
            onChange={() =>
              props.onChange({ [Object.keys(props.field)[0]]: text })
            }
          />
        ))}

        <Form.Control
          type="text"
          value={
            !props.value || props.texts.includes(props.value) ? '' : props.value
          }
          onChange={e =>
            props.onChange({ [Object.keys(props.field)[0]]: e.target.value })
          }
        />
      </FormRow>
    </div>
  );
};

const f = (b: boolean | undefined | null) => b || false;
